export default __webpack_public_path__ + "static/media/gun-related.be423b46.txt";